import { store } from "../store";

import notify from 'devextreme/ui/notify';

export function get(url) {

    return fetchApi(url, "GET").then(response => {
        return response;
    });
}

export function getById(url, id, withLinkedTables = false) {
    checkEmpty(url);
    return get(url + (withLinkedTables ? "withLinkedTables/" : "") + id).then((response) => {
        return response;
    });
}

export function post(url, data) {
    return fetchApi(url, "POST", data).then(response => {
        return response;
    });
}

export function put(url, id, data) {
    checkEmpty(url);
    return fetchApi(url + id, "PUT", data).then(response => {
        return response;
    });
}

export function deleteById(url, id) {
    checkEmpty(url);
    return fetchApi(url + id, "DELETE").then(response => {
        return response;
    });
}

function fetchApi(url, method, data = null) {
    checkEmpty(url);

    var sessionID = store.getters["account/sessionID"];

    if (!url.includes("sessionID")) {
        if (url.includes("?"))
            url += "&sessionID=" + sessionID;
        else
            url += "?sessionID=" + sessionID;
    }

    var request = prepareRequest(url, method, data);
    return fetch(request).then(handleResponse);
}

function checkEmpty(url) {
    if (typeof url === "undefined" || url === null || url === "")
        throw "fetch url is empty";
}

function prepareRequest(url, method, data) {

    if (url.toLowerCase().includes("sessionid"))
        url = url + "&ClientVersion=" + window.___GOP.VueClientDateTimeStamp;

    var headers = {};
    var body = null;

    if (data instanceof FormData)
        body = data;
    else {
        headers["Content-Type"] = "application/json";
        body = data ? JSON.stringify(data) : null;
    }

    var prefix = window.___GOP.ApiPrefix;
    if (prefix != "" && prefix != null) {
        if (!url.startsWith("/"))
            prefix = prefix + "/";
    }

    return new Request(prefix + url,
        {
            method: method, // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            credentials: 'same-origin', // include, *same-origin, omit
            redirect: 'follow', // manual, *follow, error
            referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
            headers,
            body
        }
    );
}

function handleResponse(response) {
    if (!response.ok) {

        //ok: false
        //status: 503
        //statusText: "Service Unavailable"
        //url: "http://localhost:8080/api/login"

        const error = new Object();
        error.response = response;
        error.message = "???";
        if (response.statusText)
            error.message = response.statusText;
        return handleError(error);
    }

    return response.json().then(
        response => {
            if (response.RespnseStatus == 1) {
                store._actions["account/logout"][0]({ clientOnly: true, sessionID: store.getters["account/sessionID"] });
                location.reload(true);
            }

            if (response.RespnseStatus == 0) {
                if (response.SuccessMessage)
                    notify({ message: response.SuccessMessage, width: 700 }, "success", 1000);
                return response;
            }

            //bool Success 
            //object Exception 
            //string SuccessMessage 
            //string ErrorMessage 
            //string ValidationErrorMessage    
            //string ExceptionDetail 

            var error = { "message": response.ErrorMessage, "response": response };
            return handleError(error);
        }
    );
}

function handleError(err) {
    console.error("Fetch API Error:\n", err);

    var uniqueID = "id" + "_" + Math.floor(Math.random() * 1000) + "_" + Math.floor(Math.random() * 1000);

    err.notifyUniqueID = uniqueID;

    if (err.response && err.response.ValidationErrorMessage && err.response.ValidationErrorMessage != null) {
        notify({ message: err.response.ValidationErrorMessage, width: 500, shading: true, closeOnClick: true, closeOnOutsideClick: true, elementAttr: { id: uniqueID, ref: uniqueID } }, "error", 500000);
    }
    else if (err.response && err.response.ExceptionDetail && err.response.ExceptionDetail != null) {
        notify({ message: err.ErrorMessage + " " + err.response.ExceptionDetail, width: 500, shading: true, closeOnClick: true, closeOnOutsideClick: true, elementAttr: { id: uniqueID, ref: uniqueID } }, "error", 500000);
    }
    else if (err.response &&
        err.response.title) {

        var msg = err.response.title;
        if (err.response.errors) {

            var keys = Object.keys(err.response.errors);

            for (var i = 0; i < keys.length; i++) {
                msg += " " + err.response.errors[keys[i]];
            }
        }

        notify({ message: msg, width: 500, shading: true, closeOnClick: true, closeOnOutsideClick: true, elementAttr: { id: uniqueID, ref: uniqueID } }, "error", 500000);
    }
    else if (err.response &&
        err.response.Exception &&
        err.response.Exception.FieldPermissions &&
        err.response.Exception.RowValidationErrors &&
        err.response.Exception.RowValidationErrors.ValidationErrors) {

        var errors = Object
            .entries(err.response.Exception.RowValidationErrors.ValidationErrors)
            .map(x => x[1].ErrorMessage)

        var contentTemplate = () => {
            var tableRows = "";
            errors.forEach(error => tableRows += `<tr><td>${error}</td></tr>`)
            return `<div><table>${tableRows}</table></div>`
        }

        notify({ contentTemplate, width: 500, shading: true, closeOnClick: true, closeOnOutsideClick: true }, "error", 500000);
    }
    else if (err.message && err.message != null) {
        notify({ message: err.message, width: 500, shading: true, closeOnClick: true, closeOnOutsideClick: true, elementAttr: { id: uniqueID, ref: uniqueID } }, "error", 500000);
    }



    return Promise.reject(err);
}